module.exports = __webpack_public_path__ + "static/media/ic_more_option.6de36393.svg";